import { api } from '@/api';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import { AppPermissionsEnum } from '@/api/generator';

export const usePermissionsStore = defineStore('permissions', () => {
  const permissions = ref<AppPermissionsEnum[]>();

  function hasPermissions(neededPermissions: AppPermissionsEnum[], mode: 'ALL' | 'ONE' = 'ALL') {
    if (neededPermissions.length) {
      switch (mode) {
        case 'ALL':
          return neededPermissions.every((neededPermission) =>
            permissions.value?.includes(neededPermission),
          );
        case 'ONE':
          return neededPermissions.some((neededPermission) =>
            permissions.value?.includes(neededPermission),
          );
      }
    } else {
      return true;
    }
  }

  async function fetchMyPermissions() {
    const { result } = await api.account.getUsersPermissions();
    if (result) {
      permissions.value = result;
    }
  }

  return {
    hasPermissions,
    fetchMyPermissions,
    permissions,
  };
});
